/**
 * Calculator Cart Override
 * La app Custom Price Calculator usa XHR POST a /cart/add (HTML endpoint),
 * causando redirect al carrito. Este script intercepta el XHR, lo aborta,
 * y hace su propio fetch a /cart/add.js para abrir el cart drawer.
 */
(function () {
  // console.log('[CalcOverride] Script loaded');

  // After reload: open cart drawer if flagged
  if (sessionStorage.getItem('calc-open-cart')) {
    sessionStorage.removeItem('calc-open-cart');
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      }
    }, 500);
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._calcMethod = method;
    this._calcUrl = url;

    if (
      method === 'POST' &&
      typeof url === 'string' &&
      url.indexOf('/cart/add') !== -1 &&
      url.indexOf('/cart/add.js') === -1 &&
      document.getElementById('calculator')
    ) {
      this._calcIntercepted = true;
      // console.log('[CalcOverride] Intercepted XHR.open:', method, url);
    }

    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._calcIntercepted) {
      // console.log('[CalcOverride] Intercepted XHR.send — aborting app request, doing own fetch');

      var xhr = this;

      // Do our own fetch to /cart/add.js with the same body
      fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        headers: body instanceof FormData ? {} : { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          // console.log('[CalcOverride] Fetch success:', data.title || data.product_title || 'item added');

          if (data.status && data.status >= 400) {
            // console.log('[CalcOverride] Shopify error:', data.description || data.message);
            alert(data.description || data.message || 'Error adding to cart');
            return;
          }

          // Flag to open cart drawer after reload, then reload
          sessionStorage.setItem('calc-open-cart', '1');
          // console.log('[CalcOverride] Reloading page after successful add-to-cart');
          window.location.reload();
        })
        .catch(function (err) {
          // console.error('[CalcOverride] Fetch error:', err);
        });

      // Don't send the app's original XHR at all — just return without calling origSend
      return;
    }

    return origSend.apply(this, arguments);
  };
})();
